import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { GALLERY } from "@/data/content";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery" className="bg-brand-cream py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-brown mb-4">Image Gallery</p>
          <h2 className="font-heading font-bold text-brand-ink tracking-tight text-3xl sm:text-5xl max-w-2xl leading-[1.05]">
            Machinery, fields & farmers in action.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3">
          {GALLERY.map((g, i) => {
            const span = [0, 3, 5].includes(i) ? "md:col-span-2 md:row-span-2 md:auto-rows-auto" : "";
            return (
              <Reveal key={i} delay={(i % 4) * 0.05} className={`${span} relative group overflow-hidden rounded-xl cursor-zoom-in`}>
                <motion.img
                  src={g.src}
                  alt={g.label}
                  data-testid={`gallery-image-${i}`}
                  className="size-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.35]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="absolute bottom-3 left-3 font-mono text-xs uppercase tracking-wider text-brand-cream opacity-0 group-hover:opacity-100 transition-opacity">{g.label}</span>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
